import { Button } from '@kerfjs/ui/button';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { MessageComposer } from '@kerfjs/ui/message-composer';
import { Row } from '@kerfjs/ui/row';
import { StateBanner } from '@kerfjs/ui/state-banner';
import type { SafeHtml } from 'kerfjs';
import { ArrowUp } from 'lucide';

import { chatReadOnly, chatSending } from '../../../data/state.js';
import { ACTING_READ_ONLY_REASON, actingReadOnly } from '../../../lib/acting-read-only.js';

/** A Kerf message composer below the transcript; closed conversations show a StateBanner. */
export function ChatComposer(): SafeHtml {
  const sending = chatSending.value;
  const acting = actingReadOnly();
  return chatReadOnly.value || acting ? (
    <StateBanner
      tone="neutral"
      title={acting ? ACTING_READ_ONLY_REASON : 'This demand is closed.'}
      detail="The conversation is read-only."
    />
  ) : (
    <Row controlInsets="trbl">
      <MessageComposer
        label="Message the Assistant"
        name="chat-input"
        placeholder="Ask a question…"
        disabled={sending}
        className="chat-composer"
        trailing={
          <Button
            tone="brand"
            emphasis="primary"
            size="compact"
            action="chat-send"
            disabled={sending}
            ariaLabel={sending ? 'Sending…' : 'Send'}
          >
            <LucideIcon icon={ArrowUp} name="" />
          </Button>
        }
      />
    </Row>
  );
}
